export const defaultUpdateAccessConfig = [
    {
      "name": "updateAccessConfig",
      "type": "List",
      "value": [
      ],
      "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
      "description": "update-access-config",
      "defaultValue": null,
      "possibleVals": []
    }
  ]